import { getHostname } from "./getHostName";

// https://stackoverflow.com/a/28054735
export const isExternal = (url: string) => {
  return (url.indexOf(":") > -1 || url.indexOf("//") > -1) && getHostname(location.href) !== getHostname(url);
};
